/* 1.引入文件 */
import axios from "axios"; //引入 axios库
import qs from "qs"; //引入 node中自带的qs模块（数据格式转换）
import JSONbig from 'json-bigint'
import { Message } from 'element-ui';
import { showScreenLoading, hideScreenLoading } from "./loading";

/* 2.全局默认配置 */
// 获取当前页面协议（http: 或 https:）
const protocol = window.location.protocol;
let baseURL = `${protocol}//api-guanxing.changwankeji.com/api/`;
// 判断开发环境（一般用于本地代理）
if (process.env.NODE_ENV === "development") {
  // 开发环境
  baseURL = "/api"; // 你设置的本地代理请求（跨域代理），下文会详细介绍怎么进行跨域代理
} else {
  // 编译环境
  if (process.env.type === "test") {
    // 测试环境
    baseURL = `${protocol}//api-douyin.h5uc.com`;
  } else {
    // 正式环境
    baseURL = `${protocol}//api-guanxing.changwankeji.com/api/`;
  }
}
let baseURLMap = {
  erp: {
    test: `${protocol}//test.erp.changwankeji.com:8080`,
    prod: `${protocol}//erp.changwankeji.com:8188`,
  }
}
if(location.href.includes("test.guanxing")) {
  baseURLMap.erp.prod = `${protocol}//test.erp.changwankeji.com:8080`
  //baseURLMap.erp.prod = 'https://erp.changwankeji.com:8188'
} else if (location.href.includes("pre-prod.guanxing")) {
  baseURLMap.erp.prod = `${protocol}//pre-erp.changwankeji.com:8080`
}
// 配置axios的属性
axios.defaults.timeout = 60000; // 请求超时时间1分钟
axios.defaults.baseURL = baseURL; // 你的接口地址
// axios.defaults.responseType = "json";
axios.defaults.withCredentials = true; //是否允许带cookie这些
axios.defaults.transformResponse = [function (data) {
  try {
  //作用1：把json字符串转为js对象
  //作用2：把里面的大数字做安全处理
   return JSONbig.parse(data)
  }catch(err){
   return data;
  }
}]
/*你也可以创建一个实例，然后在实例中配置相关属性，此方法和上面的方法一样，写法不同，怎么用随个人
 *喜好，我比较喜欢用这种方法，如下：
 */
const Axios = axios.create({
  baseURL: baseURL, // 后台服务地址
  timeout: 60000, // 请求超时时间1分钟
  // responseType: "json",
  withCredentials: true, // 是否允许带cookie这些
});

/* 3.设置拦截器 */

/*如果不是用创建实例的方式配置，那么下面的Axios都要换成axios,也就是文件开头你用import引入axios
时定义的变量*/
Axios.interceptors.request.use(
  (config) => {
    // 发送请求前进行拦截
    //  可在此处配置请求头信息
    // config.headers["appkey"] ="...";
    // config.headers["token"] ="...";
    //        ...
    if (config.method == "post") {
      /*数据转换: axios post方式默认是json格式提交数据，如果使用application/x-www-form-urlencoded数据格式提交，要用qs.stringify()进行转换,个人建议不在拦截器中全局配置，因为不够灵活，还有一点是，如果
设置了重新请求的配置，那么重新请求时，请求体中的config里面的传参就会被再次进行qs.stringify()转
换，会使得参数丢失，造成请求失败。*/

      if (config.headers['Content-Type'] !== 'multipart/form-data') {//文件上传
        config.data = qs.stringify(config.data);
      }
    }
    if (/(api.php)/.test(config.url)){
      if (process.env.NODE_ENV === "development") {
        config.baseURL = '/erp'
      } else {
        config.baseURL = baseURLMap.erp.prod
      }
      let token = localStorage.getItem('api_token')
      let adminid = localStorage.getItem('uid')
      let deviceid = localStorage.getItem('deviceid')
      config.headers['authid'] = adminid
      config.headers['authtoken'] = token
      config.params = Object.assign({}, config.params, {
        // token,
        // adminid,
        deviceid,
      })
      config.showLoading = config?.headers?.showLoading //世明的接口showLoading 是直接在config中传入；crm相关接口在header中
    }
    if(config.url?.includes('author-collect')) {
      config.showLoading = false //原本的收藏接口  现在世明用这个做日志统计
    }

    // if (config?.showLoading !== false && (config.url?.includes('author-login') || /(api.php)/.test(config.url))) {
    if (config?.showLoading !== false && location.pathname !== "/daren") {
      console.log('有展示loading的接口  config :>> ', config);
      // showScreenLoading();
    }

    return config;
  },
  (error) => {
    //console.log("错误的传参", 'fail');
    return Promise.reject(error);
  }
);
Axios.interceptors.response.use(
  (res) => {
    // 请求响应后拦截;
    if (res.status == 200) {
      // if (res?.config?.showLoading !== false && (res.config.url?.includes('author-login') || /(api.php)/.test(res.config.url))) {
      if (res?.config?.showLoading !== false && location.pathname !== "/daren") {
        // hideScreenLoading();
      }
      // 对响应数据做些事
      if (/(api.php)/.test(res.config.url)) {
        if (res.data.code === 200) {
          if (/(responsetype=crm)/.test(res.config.url)) {
            //有responsetype=crm的url按crm的层级返回
            return Promise.resolve(res?.data);
          }
          return Promise.resolve(res?.data?.data);
        } else if (res.data.code == 199) {
            Message({
              type: 'warning',
              message: '当前观星登录状态已失效，请前往ERP系统重新进入观星！'
            })
            return Promise.reject(res.data);
        } else {
          if(!res?.config?.headers?.hideTip) {
            Message({
              type: 'warning',
              message: res.data.msg
            })
          }
          return Promise.reject(res.data);
        }
      // }else{
      //   // 世明的接口
      //   console.log('res :>> ', res);
      //   if(res.data.code !== 0) {
      //     Message({
      //       type: 'warning',
      //       message: res.data?.error || "网络异常"
      //     })
      //   }
      }
      //alert("提交成功")
      return Promise.resolve(res);
    }

    return res;
  },
  (error) => {
    hideScreenLoading();
    console.log('error :>> ', error);
    // alert("网络异常!") //404等问题可以在这里处理
    Message({
      type: 'warning',
      message: "网络异常！请稍后再试"
    })
    return Promise.reject(error);
  }
);

Axios.all = axios.all
export default Axios;

export { baseURLMap }